import { Box, CircularProgress } from "@mui/joy";
import DarkTypography from "../../../common/DarkTypography";
import { colorTokens, ctaAccentColor, withAlpha } from "../../../../styles/globalStyles";

export default function TrainingTemplatesImportOverlay(props: { open: boolean }) {
  const { open } = props;

  if (!open) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        backgroundColor: withAlpha(colorTokens.bg.overlay, 0.6),
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1300,
        pointerEvents: "auto",
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }}>
        <CircularProgress size="lg" />
        <DarkTypography sx={{ color: ctaAccentColor }}>Import en cours…</DarkTypography>
      </Box>
    </Box>
  );
}
